import React, { useEffect } from 'react'
import { AuthWithCartoon } from 'pages/Auth'
import { Button, Form } from 'components/Form'
import { constants } from './hooks'
import { ForgotUserNameOrPassword, Logo, LoginStyles } from '../Style'
import { app } from 'router/routes'
import { LgSpace, Link, Space } from 'styles/GlobalStyle'
import { LoginCart } from 'assets'
import { loginHooks, validate } from '.'
import { Divider, SvgIcon } from '@mui/material'
import { CreateTicketFab } from 'pages/CreateTicket'
import { ReactComponent as LogoIcon } from 'assets/LogoGo.svg';
import { ReactComponent as MinistryEducationIcon } from 'assets/icons/MinistryEducation.svg';
import { ReactComponent as GoogleIcon } from 'assets/icons/Google.svg';
import { useAlert } from 'components/Alerts/hooks'
import { checkAndRefreshDaily } from 'utils/general'

const Login = () => {
    const { login } = loginHooks.useLogin()
    const { forgotPassword, forgotUsername, register } = constants
    const { formname, title } = loginHooks.constants

    const submitBtn = loginHooks.useSubmitBtn()
    const fields = loginHooks.useFields()
    const { setAlerts } = useAlert()

    useEffect(() => {
        // קריאה לפונקציית בדיקת הרענון באתר
        checkAndRefreshDaily();
    }, [])

    return (
        <>
            <LoginStyles>
                <Logo>
                    <SvgIcon component={LogoIcon} color="black" inheritViewBox />
                </Logo>
                <AuthWithCartoon
                    cartoon={LoginCart}
                    cartoonSize={{
                        height: 600,
                    }}
                >
                    <Form
                        form={formname}
                        title={title}
                        submit={login}
                        validations={validate}
                        fields={fields}
                        submitBtns={[]}
                        rowGap={10}
                    />
                    <div className='forgot-username-or-password'>
                        <ForgotUserNameOrPassword>
                            <Link to={app.recoverUsername}>{forgotUsername}</Link>
                            {"/"}
                            <Link to={app.reset}>{forgotPassword}</Link>
                        </ForgotUserNameOrPassword>
                        <div>
                            <Button {...submitBtn} />
                        </div>
                    </div>
                    <LgSpace />
                    <Divider className='divider2' />
                    <Space />
                    <div className='login-options'>
                        <Button disabled={true}>
                            <div className='login-option-icon'>
                                <SvgIcon fontSize='large' component={MinistryEducationIcon} inheritViewBox />
                            </div>
                            <div className='login-option-label'>
                                <a
                                    data-testid="linkElement"
                                    href={process.env.REACT_APP_LOGIN_SAML_PORT}
                                    target="_self" class="uDW_Qe wixui-button PlZyDq" aria-disabled="false" aria-label="הזדהות משרד החינוך"><span class="l7_2fn wixui-button__label">הזדהות משרד החינוך</span></a>
                            </div>
                        </Button>
                        <Button disabled={true}>
                            <div className='login-option-icon'>
                                <SvgIcon fontSize='large' component={GoogleIcon} inheritViewBox />
                            </div>
                            <div className='login-option-label'>
                                {"כניסה דרך חשבון גוגל"}
                            </div>
                        </Button>
                    </div>
                </AuthWithCartoon>
                <div className="footer-message">{"This website is an educational platform for assessing and improving children's reading skills. It provides reading assessments, progress tracking, and personalized learning tools for students, teachers, and educational institutions."}</div>

            </LoginStyles>
            <CreateTicketFab />
        </>
    )
}

export default Login
